/**
 * Client-side payment amount validation.
 * Mirrors backend/utils/amount_limits.py — backend remains authoritative.
 */

export const WALLET_MIN_AMOUNT = 100;
export const ABSOLUTE_MAX_SINGLE = 10_000_000;
export const DEFAULT_PROVIDER_MIN = 100;
export const DEFAULT_PROVIDER_MAX = 1_000_000;

export function validateWalletAmount(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value) || value <= 0) {
    return { valid: false, message: "Amount must be greater than zero" };
  }
  if (value < WALLET_MIN_AMOUNT) {
    return { valid: false, message: `Minimum amount is MWK ${WALLET_MIN_AMOUNT.toLocaleString()}` };
  }
  if (value > ABSOLUTE_MAX_SINGLE) {
    return { valid: false, message: `Maximum amount is MWK ${ABSOLUTE_MAX_SINGLE.toLocaleString()}` };
  }
  return { valid: true, value };
}

export function validateProviderAmount(amount, provider) {
  const value = Number(amount);
  if (!Number.isFinite(value) || value <= 0) {
    return { valid: false, message: "Amount must be greater than zero" };
  }

  const min = Number(provider?.min_amount ?? DEFAULT_PROVIDER_MIN);
  const max = Number(provider?.max_amount ?? DEFAULT_PROVIDER_MAX);
  const label = provider?.name || provider?.code || "provider";

  if (value < min) {
    return { valid: false, message: `Minimum amount for ${label} is MWK ${min.toLocaleString()}` };
  }
  if (value > max) {
    return { valid: false, message: `Maximum amount for ${label} is MWK ${max.toLocaleString()}` };
  }
  if (value > ABSOLUTE_MAX_SINGLE) {
    return { valid: false, message: `Amount exceeds platform maximum of MWK ${ABSOLUTE_MAX_SINGLE.toLocaleString()}` };
  }
  return { valid: true, value };
}

export function providerAmountBounds(provider) {
  return {
    min: Number(provider?.min_amount ?? DEFAULT_PROVIDER_MIN),
    max: Number(provider?.max_amount ?? DEFAULT_PROVIDER_MAX),
  };
}
